/**
 * Stage Packs Registry
 *
 * Centralizes all stage pack definitions and provides auto-registration.
 */

import { registerStagePack } from "@/babylon/context/StageContext";
import { bobStagePack } from "./bob.stage";
import { gemStagePack } from "./gem.stage";
import { runeStagePack } from "./rune.stage";

// Export individual stage packs
export { bobStagePack } from "./bob.stage";
export { gemStagePack } from "./gem.stage";
export { runeStagePack } from "./rune.stage";

/**
 * All available stage packs
 */
export const ALL_STAGE_PACKS = [gemStagePack, bobStagePack, runeStagePack];

/**
 * Register all stage packs with the StageContext
 * Call this once at app initialization
 */
export function registerAllStagePacks(): void {
  for (const pack of ALL_STAGE_PACKS) {
    registerStagePack(pack);
  }
}
